import React, { createContext, useContext, useState, useEffect } from "react";
import { getCartItemsCount, getFavoritesCount } from "../utils/localStorage";

// إنشاء Context
const CartContext = createContext();

// Hook مخصص لاستخدام Context
export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error("useCart must be used within a CartProvider");
  }
  return context;
};

// Provider Component
export const CartProvider = ({ children }) => {
  const [cartCount, setCartCount] = useState(0);
  const [favoritesCount, setFavoritesCount] = useState(0);

  // تحديث الأعداد من localStorage
  const updateCounts = () => {
    setCartCount(getCartItemsCount());
    setFavoritesCount(getFavoritesCount());
  };

  // تحديث الأعداد عند تحميل المكون
  useEffect(() => {
    updateCounts();

    // إضافة مستمع للتغييرات في localStorage
    const handleStorageChange = (e) => {
      if (e.key === "cart" || e.key === "favorites") {
        updateCounts();
      }
    };

    // مستمع للتغييرات من نفس التبويب
    const handleCustomStorageChange = () => {
      updateCounts();
    };

    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("cartUpdated", handleCustomStorageChange);
    window.addEventListener("favoritesUpdated", handleCustomStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("cartUpdated", handleCustomStorageChange);
      window.removeEventListener("favoritesUpdated", handleCustomStorageChange);
    };
  }, []);

  // دالة لتحديث عدد السلة
  const updateCartCount = () => {
    const newCount = getCartItemsCount();
    setCartCount(newCount);
    // إرسال حدث مخصص لتحديث المكونات الأخرى
    window.dispatchEvent(new CustomEvent("cartUpdated"));
  };

  // دالة لتحديث عدد المفضلة
  const updateFavoritesCount = () => {
    const newCount = getFavoritesCount();
    setFavoritesCount(newCount);
    // إرسال حدث مخصص لتحديث المكونات الأخرى
    window.dispatchEvent(new CustomEvent("favoritesUpdated"));
  };

  console.log(cartCount);

  const value = {
    cartCount,
    favoritesCount,
    updateCartCount,
    updateFavoritesCount,
    updateCounts,
  };

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};
